import { render } from "./googleoauth.vue?vue&type=template&id=e2e7ce6e&scoped=true"
import script from "./googleoauth.vue?vue&type=script&lang=js"
export * from "./googleoauth.vue?vue&type=script&lang=js"

import "./googleoauth.vue?vue&type=style&index=0&id=e2e7ce6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e7ce6e"]])

export default __exports__